import AlertDialog from './AlertDialog';

export default { 
  name: "alert", 
  component: AlertDialog, 
  fullScreen: false
};